import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.cdp.cof";
export interface LensesSignals {
    lastLensActivatedTime: string;
    lastSnappableLensActivatedTime: string;
    isAnyEffectApplied: boolean;
}
function createBaseLensesSignals(): LensesSignals {
    return { lastLensActivatedTime: "0", lastSnappableLensActivatedTime: "0", isAnyEffectApplied: false };
}
export const LensesSignals: MessageFns<LensesSignals> = {
    encode(message: LensesSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.lastLensActivatedTime !== "0") {
            writer.uint32(8).uint64(message.lastLensActivatedTime);
        }
        if (message.lastSnappableLensActivatedTime !== "0") {
            writer.uint32(16).uint64(message.lastSnappableLensActivatedTime);
        }
        if (message.isAnyEffectApplied !== false) {
            writer.uint32(24).bool(message.isAnyEffectApplied);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): LensesSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensesSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.lastLensActivatedTime = reader.uint64().toString();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.lastSnappableLensActivatedTime = reader.uint64().toString();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.isAnyEffectApplied = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<LensesSignals>, I>>(base?: I): LensesSignals {
        return LensesSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<LensesSignals>, I>>(object: I): LensesSignals {
        const message = createBaseLensesSignals();
        message.lastLensActivatedTime = object.lastLensActivatedTime ?? "0";
        message.lastSnappableLensActivatedTime = object.lastSnappableLensActivatedTime ?? "0";
        message.isAnyEffectApplied = object.isAnyEffectApplied ?? false;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
